import { DocumentsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import DocumentNavigator from 'modules/documents/components/DocumentNavigator'
import { DocumentViewerContentProps } from 'modules/documents/components/DocumentPreview'
import { Document } from 'modules/documents/hooks/documents/useGetDocuments'

interface Props {
  content?: (props: DocumentViewerContentProps) => React.ReactElement
  documentIds: number[]
  index: number
  onClose: () => void
  onNavigateToOtherDocument?: (document: Document | undefined) => void
  contractVersions: ContractVersions
}

// This adapter is used to make the DocumentNavigator component compatible with component which cannot load DocumentItems
// Use DocumentNavigator if the component has the document array instead of this adapter
const DocumentNavigatorCompatible = ({
  onClose,
  content,
  documentIds,
  index,
  onNavigateToOtherDocument,
  contractVersions,
}: Props) => {
  const { data } = useQuery(DocumentsDocument, { variables: { ids: documentIds } })
  const documents = data?.documents.documents || []

  return (
    <DocumentNavigator
      documents={documents}
      index={index}
      onClose={onClose}
      content={content}
      onNavigateToOtherDocument={onNavigateToOtherDocument}
      contractVersions={contractVersions}
    />
  )
}

export default DocumentNavigatorCompatible
